import type { IconProps } from '../types/IconProps.ts';
export const Wallet: IconProps = {
    name: 'Wallet',
    children: [
        `<path d="M21 7h-3m0 0H5a2 2 0 1 1 0-4h11a2 2 0 0 1 2 2zM21 12V7" />`,
        `<path d="M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5" />`,
        `<path d="M17 14c0-1.1.9-2 2-2h2.93q.06 0 .07.07v3.86q0 .06-.07.07H19a2 2 0 0 1-2-2" />`,
    ]
};